import { Typography, Row, Col, Card, Avatar, Rate } from 'antd';
import { User, Code, PenTool, BookOpen, Share2, Briefcase } from 'lucide-react';

const { Title, Paragraph } = Typography;

const testimonials = [
    {
        name: "Sarah Chen",
        role: "UX Designer",
        icon: <PenTool size={18} />,
        bg: "linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)",
        quote: "I collect design inspiration from all over the web. Page Notes keeps my thoughts attached to the exact source. It's my second brain for creativity.",
        rating: 5
    },
    {
        name: "Alex Rivera",
        role: "Software Engineer",
        icon: <Code size={18} />,
        bg: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
        quote: "Finally, a notepad that speaks Markdown natively. I use it to document libraries and save code snippets directly on the documentation pages.",
        rating: 5
    },
    {
        name: "Dr. Emily Weiss",
        role: "Research Scientist",
        icon: <BookOpen size={18} />,
        bg: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
        quote: "The AI summarizer is a lifesaver. I can digest complex papers in minutes and my notes stay linked to the PDF or article forever.",
        rating: 5
    },
    {
        name: "James Xu",
        role: "Tech Influencer",
        icon: <Share2 size={18} />,
        bg: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
        quote: "I research content for my channel constantly. Page Notes helps me script videos while I browse. The cross-platform sync is flawless.",
        rating: 5
    },
    {
        name: "Marcus Johnson",
        role: "Product Manager",
        icon: <Briefcase size={18} />,
        bg: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        quote: "Meeting notes used to be a mess. Now they just stick to the GMeet or Zoom tab. My team loves the encrypted sharing feature.",
        rating: 5
    },
    {
        name: "Priya Patel",
        role: "Medical Student",
        icon: <User size={18} />,
        bg: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
        quote: "I stopped using three different apps for studying. Highlighting, summarizing, and flashcards all happen right on the textbook website now.",
        rating: 5
    }
];

export default function TestimonialsSection() {
    return (
        <div className="section testimonials-section">
            <div className="section-container">
                <div className="section-header">
                    <Title level={2}>Loved by Thinkers & Creators</Title>
                    <Paragraph className="section-subtitle">
                        Join thousands of students, professionals, and creatives who have upgraded their web workflow.
                    </Paragraph>
                </div>

                <div className="testimonials-grid">
                    {/* Masonry-style layout effect using columns */}
                    <Row gutter={[24, 24]}>
                        {testimonials.map((t, i) => (
                            <Col xs={24} md={12} lg={8} key={i}>
                                <Card className="testimonial-card" bordered={false}>
                                    <div className="testimonial-header">
                                        <div className="avatar-wrapper" style={{ background: t.bg }}>
                                            {t.icon}
                                        </div>
                                        <div>
                                            <div className="author-name">{t.name}</div>
                                            <div className="author-role">{t.role}</div>
                                        </div>
                                    </div>
                                    <div className="testimonial-stars">
                                        <Rate disabled defaultValue={t.rating} style={{ fontSize: 12, color: '#fbbf24' }} />
                                    </div>
                                    <Paragraph className="testimonial-quote">
                                        "{t.quote}"
                                    </Paragraph>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    );
}
